export default __webpack_public_path__ + "static/media/789.9ec5a17c.gif";